// let local='http://localhost:5000';
// let api=local;

let server='https://random-gym-exercise.vercel.app';
let api=server;

export default api;